import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@client';
import { SupplierLegalEntityDetailsResponse } from '@state/types/SupplierLegalEntityDetailsResponse';
import { SupplierLegalEntityDetailsDTO } from '@state/types/SupplierLegalEntityDetailsDTO';

export const supplierLegalEntityDetailsApi = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: ['supplierLegalEntityDetails'],
  reducerPath: 'legal-entity-details-api',
  endpoints: (build) => ({
    loadLegalEntityDetails: build.query<
      SupplierLegalEntityDetailsResponse,
      { supplierId: string }
    >({
      query: ({ supplierId }) => ({
        url: `/secured/supplier/${supplierId}/legal-entity-details`,
        method: 'GET'
      }),
      providesTags: (res, _error, { supplierId }) =>
        res
          ? [{ type: 'supplierLegalEntityDetails', id: supplierId }]
          : ['supplierLegalEntityDetails']
    }),
    saveLegalEntityDetails: build.mutation<
      SupplierLegalEntityDetailsResponse,
      { supplierId: string; formData: SupplierLegalEntityDetailsDTO }
    >({
      query: (data) => ({
        url: `/secured/supplier/${data.supplierId}/legal-entity-details`,
        method: 'POST',
        data: data.formData
      }),
      invalidatesTags: (res, _error, { supplierId }) =>
        res
          ? [{ type: 'supplierLegalEntityDetails', id: supplierId }]
          : ['supplierLegalEntityDetails']
    })
  })
});

export const {
  useLoadLegalEntityDetailsQuery,
  useSaveLegalEntityDetailsMutation
} = supplierLegalEntityDetailsApi;
